import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-admin-course',
  templateUrl: './admin-course.component.html',
  styleUrls: ['./admin-course.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminCourseComponent implements OnInit {

  courseForm: FormGroup;
  public courseDetails: any;
  public courseList: Array<any> = [];

  constructor(private formBuilder: FormBuilder, private _ref: ChangeDetectorRef, private _adminService: AdminService) {
    this.courseForm = this.formBuilder.group({
      courseTitle: ['', [Validators.required, Validators.minLength(3)]],
      courseSubTitle: ['', [Validators.required, Validators.minLength(3)]],
      courseDescription: ['', [Validators.required, Validators.minLength(3)]],
      courseCategory: ['', [Validators.required, Validators.minLength(3)]],
      courseTags: ['', [Validators.required, Validators.minLength(3)]],
      courseImagePath: ['', []],
      courseSampleFilePath: ['', []],
      courseFilePath: ['', []],
      courseAmount: ['', [Validators.required, Validators.minLength(3)]],
      courseAuthors: ['', [Validators.required, Validators.minLength(3)]],
      courseRating: ['', []],
      courseFinishTime: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit() {
    this.getAllCourses();
  }

  getAllCourses() {
    this._adminService.getAllCourses().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.courseList = response;
        else this.courseList = [];

        this.courseDetails = null;
        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.courseDetails = null;
        this.courseList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  getCourseById(courseId: any) {
    if (!courseId) {
      alert("Valid course not selected for edit.");
      return;
    } else {
      this._adminService.getCourseById(courseId).subscribe({
        next: (response: any) => {
          if (response) this.courseDetails = response;
          else this.courseDetails = null;

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          this.courseDetails = null;
          this._ref.markForCheck();
          console.log(error);
        },
      });
    }
  }

  clickOnSubmit() {
    if (this.courseDetails && this.courseDetails != null) {
      this.updateAdminCourse(this.courseDetails?._id);
    } else {
      this.saveAdminCourse();
    }
  }

  saveAdminCourse() {
    if (!this.courseForm.valid) {
      alert("Course is not have valid details.");
      this.courseForm.markAllAsTouched();
      return;
    } else {
      this._adminService.postCourse(this.courseForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Course insert successful.");
            this.courseForm.reset();
            this.getAllCourses();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  updateAdminCourse(courseId: any) {
    if (!courseId && !this.courseForm.valid) {
      alert("Course is not have valid details.");
      this.courseForm.markAllAsTouched();
      return;
    } else {
      this._adminService.putCourse(courseId, this.courseForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Course update successful.");
            this.courseForm.reset();
            this.getAllCourses();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  deleteAdminCourse(courseId: any) {
    if (!courseId) {
      alert("Valid course not selected for delete.");
      return;
    } else {
      this._adminService.deleteCourse(courseId).subscribe({
        next: (response: any) => {
          if (response) {
            alert("Course delete successful.");
            this.courseForm.reset();
            this.getAllCourses();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  clearCourse() {
    this.courseForm.reset();
  }
}
